import React, { useState } from "react";
import { Button, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { BeOptModeEnum, useBeModel } from "../beModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {
    const { selectedRowKeys, selectedData, setDrawerVisible, setOptMode, disable, syncData } = useBeModel();
    const [syncLoading, setSyncLoading] = useState<boolean>(false);
    const onEdit = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setOptMode(BeOptModeEnum.EDIT);
            setDrawerVisible(true)
        } else {
            message.error("请选择实体!")
        }
    }

    const onAdd = () => {
        setOptMode(BeOptModeEnum.ADD);
        setDrawerVisible(true);
    }

    const onCheck = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setOptMode(BeOptModeEnum.DETAIL);
            setDrawerVisible(true)
        } else {
            message.error("请选择实体!")
        }
    }

    const onDisabled = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.enable === 1) {
                disable()
            } else {
                message.warning("选择实体已被禁用!")
            }
        } else {
            message.error("请选择实体!")
        }
    }
    const action = (
        <>
            <YhAuth resCode={ResourceAuthEnum.DATA_ENTITY_ADD}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAdd}
                >
                    新增
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.DATA_ENTITY_ED}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onEdit}
                >
                    修改
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.DATA_ENTITY_VW}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onCheck}
                >
                    查看
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.DATA_ENTITY_DISABLE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onDisabled}
                >
                    禁用
            </Button>
            </YhAuth>
            {/* <YhAuth resCode={ResourceAuthEnum.DATA_ENTITY_SYNC}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    loading={syncLoading}
                    onClick={() => {
                        setSyncLoading(true);
                        syncData().then(res => setSyncLoading(false)).catch(err => setSyncLoading(false));
                    }}
                >{syncLoading ? "同步中" : "同步"}</Button>
            </YhAuth> */}
        </>
    );

    return (
        <YhBox title=" " action={action}>
            <DataTable />
        </YhBox>
    )
}